<template>
  <div class="wrapper">
    <p class="title text-center">{{ $t('form.editPhone')}}</p>
    <div class="content">


      <div v-if="existPhone && !isChangePhone">
        <div class="current-phone text-center">
          <div class="text-message text-center">{{ $t('common.editPhone')}}</div>
        </div>
        <div class="new-phone">
          <div class="input-wrapper">
            <div class="row-group phone-group">
              <div class="form-group m-d-gruop existPhoneContainer">
                <b-form-input id="existPhone" v-model="existPhone" disabled/>
                <label class="existPhoneLabel" for="existPhone">{{ $t('common.phoneNumber')}}</label>
              </div>
              <button class="btn btn-primary changeExistPhone" @click="changePhoneNumber()"> {{$t('common.change')}} </button>
            </div>
          </div>
        </div>
      </div>
      <div v-else>
        <div class="current-phone text-center">
          <div class="text-message text-center">{{ $t('form.enterNewPhone')}}</div>
        </div>
        <!-- new phone  -->
        <div class="new-phone">
          <div class="input-wrapper">
            <div class="row-group phone-group justify-content-start">
              <VueCountryCode class="country-code-input" :disabledFetchingCountry="false" @onSelect="onSelectUserCountryCode"
                :enabledCountryCode="true" :preferredCountries="['GB', 'US', 'CN']"/>
              <div>
                <vpInput
                  :label="$t('common.phoneNumber')"
                  width="300"
                  v-model.trim="phone_input"
                  @input="onPhoneTyping"
                  :invalid="isPhoneDuplicate || !$v.phone_input.numeric"
                  :errMsg="isPhoneDuplicate ? $t('form.phoneAlreadyExists')  :!$v.phone_input.numeric ?$t('validation.phoneDigitsOnly') :undefined "
                />
              </div>
              <b-spinner v-if="isPhoneChanging" variant="secondary" role="status" size="sm" class="vp-input-wizard-spinner"
                :class="{'vp-input-wizard-spinner-error': isPhoneDuplicate}"/>
            </div>
          </div>
        </div>
        <!-- entity checkbox  -->
        <div class="entity-checkbox" v-if="getUserData.is_system_user" :class="{'entity-checkbox-checked':form.update_cloud}">
          <b-form-checkbox id="UpdateCloudFromPhoneCheckbox" v-model="form.update_cloud" name="update_cloud">
            {{ $t('form.updatePhoneAllCompanies')}}
          </b-form-checkbox>
        </div>
      </div>
      
    </div>
    <!-- action btns  -->
    <hr class="h-line" />
    <div class="action-btns">
      <button class="submit-btn btn btn-primary d-flex align-items-center justify-content-center" size="md" @click="onSubmit" :disabled="getLoading || (!phone_input && !userEmail ) || !isChangePhone || isPhoneDuplicate">
        <i v-if="getLoading" class="bx bx-loader bx-spin font-size-16 align-middle mr-2 rounded"></i>
        <span>{{ $t('common.save')}}</span>
      </button>
      <button
        class="btn btn-outline-danger"
        @click="$bvModal.hide('userPhone')"
      >
        {{$t('common.cancel')}}
      </button>
    </div>
  </div>
</template>

<script>
import {
  numeric,
  maxLength,
} from "vuelidate/lib/validators";
import { mapActions, mapGetters } from "vuex";
import VueCountryCode from "vue-country-code";

export default {
  components: { VueCountryCode },
  data() {
    return {
      submitted: false,
      form: {
        phone: null,
        update_cloud: false,
      },
      existPhone : null,
      phoneInputTyping: false,
      phone_input: null,
      userCountryCode: null,
      userId: null,
      isPhoneDuplicate : false,
      isChangePhone : false,
      isPhoneChanging : false,
      userEmail : null,
    };
  },
  computed: {
    ...mapGetters("user", [
      "getLoading",
      "getUserPhone",
      "getModalState",
      "getUserData",
      "getUserEmail",
    ]),
    ...mapGetters("authfack", ["getPhoneDuplicatedCheck"]),
    ...mapGetters("modal", ["getModalInfo"]),
  },
  watch: {
    getModalState(state) {
      state && this.$bvModal.hide("userPhone");
    },
    phone_input(phone_input) {
      this.form.phone = null;
      if (phone_input && phone_input.length > 0) {
        this.form.phone = `${this.userCountryCode}${phone_input}`
      }
      console.log('this.phone', this.form.phone);

    },
  },
  validations: {
    phone_input: { numeric, maxLength: maxLength(50) },
  },
  methods: {
    ...mapActions("user", ["changeUserPhoneAction", "resetState"]),
    ...mapActions("authfack", ["checkDuplicated", "resetLoading"]),
    changePhoneNumber(){
      this.isChangePhone = true;
      this.form.phone = null;
    },
    onPhoneTyping() {
      if(this.phone_input && this.phone_input.length){
        this.isPhoneDuplicate = false;
        this.isPhoneChanging = true;
        this.isChangePhone = true;
        this.submitted = false;
        setTimeout(() => {
          this.checkDuplicated({
            field: "phone",
            value: `${this.userCountryCode}${this.phone_input}`,
            user_id : this.userId
          }).then((res) => {
            console.log('res', res)
            this.isPhoneChanging = false;
            if(!res.data.data.available){
              this.isPhoneDuplicate = true;
            } 
          }).catch((e) =>{
            console.log('e',e);
          })
        },500)
      }
    },
    onSubmit() {
      this.submitted = true;        
      this.changeUserPhoneAction({
        form: {
        phone: this.phone_input ? this.form.phone : '',
        update_cloud: this.form.update_cloud,
      },
      });
    },
    onSelectUserCountryCode({ dialCode }) {
      this.userCountryCode = dialCode;
      this.form.phone = `${this.userCountryCode}${this.phone_input}`;
      this.onPhoneTyping();
    },
  },
  beforeMount() {
    this.resetLoading();
    this.resetState();
    this.userId = this.getUserData.id;
    this.existPhone = this.getUserPhone;
    this.userEmail = this.getUserEmail
  },
};
</script>

<style lang="scss" scoped>
  div#userPhone___BV_modal_content_ {

    .wrapper {
      .text-title {
        font-size: 20px;
        margin-bottom: 30px;
        text-align: center;
        color: rgba(96, 96, 96, 0.87);
        opacity: 0.8;
        font-weight: normal;
      }
      .current-password-wrapper {
        margin-bottom: 44px;
        .input-wrapper {
          padding: 0 42px !important;
        }
      }
      .h-line-password {
        margin: 0 !important;
        margin-bottom: 42px !important;
      }

      .new-password-wrapper {
        margin-bottom: 9px;
      }
      .text-hint {
        font-weight: normal;
        font-size: 14px;
        color: #939393;
        text-align: center;
        opacity: 0.8;
        margin-bottom: 33px;
      }
      .current-phone {
        margin-bottom: 24px;
      }
      input[type="text"]{
        background: #f2f2f2;
        color: #606060;
      }
      .row-group {
        display: flex;
        justify-content: space-between;
      }
      .err-wrapper {
        margin-top: 8px;
        margin-left: 125px;
      }

      .entity-checkbox{
        margin-top: 24px;
        margin-bottom: 0px !important;
        font-family: Lato;
        font-size: 16px;
        font-weight: 600;
        line-height: 19.2px;
        letter-spacing: 0.25px;
        text-align: left;
        color: #787878;
      }

      .h-line {
        margin-top: 40px !important;
        margin-bottom: 24px !important;
      }
      .phone-group {
        width: 416px;
      }

      @media (max-width: 992px){
        .phone-group {
          display: grid;
          gap: 16px;
        }
      }

      .text-message{
        font-family: Lato;
        font-size: 16px;
        font-weight: 400;
        line-height: 19.2px;
        letter-spacing: 0.25px;
        text-align: center;
        color: #4A4A4A;
      }
    }

    .changeExistPhone {
      width: 115px;
      height: 55px;
      border-radius: 4px;
      font-size: 16px;
    }

    .existPhoneContainer{
      width: 285px;
    }

    input#existPhone {
      color: #AFAFAF;
    }

    .invalid-phone-text{
      margin-top: 0px;
    }

    .existPhoneLabel {
      top: -38px;
      font-size: 12px;
      position: relative;
      font-weight: 700 !important;
      opacity: 1 !important;
      color: #9FB2BF !important;
    }
  } 
</style>
